import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  }

  isTokenExpired(exp: number): boolean {
    const currentTime = Math.floor(Date.now() / 1000); // Current time in epoch format (seconds)
    return currentTime >= exp;
  }

  canActivate(next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
      if(state.url.includes("data"))
      {
        console.log(state.url.split("&data=")[1])
        let encodedData=state.url.split("&data=")[1];
        encodedData= encodedData.substring(encodedData.length - 3) == '%3D' ? encodedData.slice(0, encodedData.length - 3) : encodedData
        try {
          const decodedJson= JSON.parse(atob(encodedData));
          localStorage.setItem("projectId",decodedJson['projectId']);
          localStorage.setItem("projectIdDb2",decodedJson['projectIdDb2']);
          localStorage.setItem("projectName",decodedJson['projectName']);
        } catch (error) {
          console.log(error)
          this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        }
      }
      let currentUser = JSON.parse(localStorage.getItem('currentUser'));
      if (currentUser && currentUser.token) {
          let parsedToken = this.parseJwt(currentUser.token);
          if (!this.isTokenExpired(parsedToken.exp)) {
            return true
          }
      }
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
}
